import { Button } from "@imi/ui/components/Button/Button.js";
import { TextFieldField } from "@imi/ui/components/TextField/TextField.js";
import { createFormHook, createFormHookContexts } from "@tanstack/react-form";
import { CheckboxField } from "../components/Checkbox/Checkbox";
import { ComboBoxField } from "../components/ComboBox/ComboBox";
import { FilterTabsField } from "../components/Filters/FilterTabs/FilterTabs";
import { OptionalFilterCardField } from "../components/Filters/OptionalFilterCard/OptionalFilterCard";
import { SelectField } from "../components/Select/Select";
import { StepperField } from "../components/Stepper/Stepper";
import { SwitchField } from "../components/Switch/Switch";
import { TabsField } from "../components/Tabs/Tabs";

export const { fieldContext, formContext, useFieldContext, useFormContext } =
  createFormHookContexts();

export const { extendForm, useAppForm: useBaseAppForm } = createFormHook({
  fieldComponents: {
    Checkbox: CheckboxField,
    ComboBox: ComboBoxField,
    FilterTabs: FilterTabsField,
    OptionalFilterCard: OptionalFilterCardField,
    Select: SelectField,
    Stepper: StepperField,
    Switch: SwitchField,
    Tabs: TabsField,
    TextField: TextFieldField,
  },
  fieldContext,
  formComponents: {
    Button,
  },
  formContext,
});
